import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type AbilitiesService from 'ember-can/services/abilities';
import type FeatureFlagsService from 'garaje/services/feature-flags';

interface VisitorsSettingsPoliciesUpdateParams {
  policy_id: string;
}

export default class VisitorsSettingsPoliciesUpdateRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare router: RouterService;

  titleToken = 'Update Policy';

  beforeModel(): void {
    if (!this.featureFlags.isEnabled('visitors-advanced-approvals-policy-drafts')) {
      void this.router.transitionTo('visitors.settings');
      return;
    }

    if (this.abilities.cannot('visit advance-settings')) {
      void this.router.transitionTo('unauthorized');
    }
  }

  model(params: VisitorsSettingsPoliciesUpdateParams): string {
    return params.policy_id;
  }
}
